export default {
    namespaced: true,

    state: {
        informe11: 'd'


    },
    mutations: {
        informe1(state) {
            console.log(state.informe11)
        }

    },
    actions: {

    },
    getters: {


    },






}